var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.235,
    height: 159.554,
    viewBox: "0 0 154.235 159.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5534",
    "data-name": "Group 5534",
    transform: "translate(-1493 -1216.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(1325 1056.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M285.252,128l13.08,44.472a5.324,5.324,0,0,1,.216,1.5v76.353H256V128Z",
    transform: "translate(-10.883 69.229)",
    fill: "#d0b28a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M338.659,349.162A2.659,2.659,0,0,1,336,346.5V290.659a2.659,2.659,0,0,1,5.318,0V346.5A2.659,2.659,0,0,1,338.659,349.162Z",
    transform: "translate(-64.29 -37.586)",
    fill: "#b49770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M117.073,250.325H24V174.516a10.646,10.646,0,0,1,.317-2.579L37.3,128h93.073L117.39,171.936a10.648,10.648,0,0,0-.317,2.58Z",
    transform: "translate(144 69.229)",
    fill: "#e8d1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M45.318,80C42.381,80,40,83.572,40,87.978s2.381,7.978,5.318,7.978h95.732V80Z",
    transform: "translate(133.318 101.274)",
    fill: "#d0b28a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M231.777,54.86a11.709,11.709,0,0,1-11.71,11.71H213.53a1.072,1.072,0,0,0-.658.226L196.276,79.7A9.05,9.05,0,0,1,184.32,66.161l16.375-16.375a1.072,1.072,0,0,0-.759-1.831H152l26.63-14.526A11.711,11.711,0,0,1,184.238,32h67.741a1.073,1.073,0,0,1,1.072,1.072V52.2a1.073,1.073,0,0,1-1.072,1.072H233.364a1.587,1.587,0,0,0-1.587,1.587Z",
    transform: "translate(58.548 133.318)",
    fill: "#e6bc9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M424,16h21.274V50.57H424Z",
    transform: "translate(-123.039 144)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M304,469.3,317.3,456l13.3,13.3Z",
    transform: "translate(-42.927 -149.742)",
    fill: "#b49770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M225.585,240l-1.579,22.191c-.019.42.315.825.923,1.124a5.352,5.352,0,0,0,2.307.459h3.02a5.351,5.351,0,0,0,2.307-.46c.609-.3.942-.7.923-1.124L231.907,240Z",
    transform: "translate(1.233 45.324)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M206.322,66.676V61.934L200,60.353S201.581,24,212.645,24V66.676Z",
    transform: "translate(20.496 218.648)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M81.585,176l-1.579,36.05a1.684,1.684,0,0,0,.923,1.43,4.39,4.39,0,0,0,2.307.585h3.02a4.39,4.39,0,0,0,2.307-.585,1.684,1.684,0,0,0,.923-1.43L87.907,176Z",
    transform: "translate(118.847 96.093)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M78.121,24a1.616,1.616,0,0,0-1.476,1.631V41.386H73.484V25.634A1.617,1.617,0,0,0,72.008,24a1.581,1.581,0,0,0-1.686,1.577V41.386H67.161V25.634A1.616,1.616,0,0,0,65.685,24,1.581,1.581,0,0,0,64,25.58V45.6a6.322,6.322,0,0,0,1.264,3.793l3.477,4.636h6.322l3.477-4.636A6.322,6.322,0,0,0,79.806,45.6V25.58A1.581,1.581,0,0,0,78.121,24Z",
    transform: "translate(131.689 218.063)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5275",
    "data-name": "Group 5275",
    transform: "translate(1336.937 1049)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 20.554,
    cy: 19.616,
    rx: 20.554,
    ry: 19.616,
    transform: "translate(189.433 171.042)",
    fill: "#a7160a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M243.282,128.917a21.766,21.766,0,0,0-2.282.121c10.4,1.11,18.271,9.5,18.271,19.495S251.4,166.917,241,168.027a21.754,21.754,0,0,0,2.282.121c11.352,0,20.554-8.782,20.554-19.616s-9.2-19.616-20.554-19.616Z",
    transform: "translate(-33.296 42.125)",
    fill: "#810c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M15.861,13.985l5.721-5.708a1.336,1.336,0,1,0-1.889-1.889l-5.708,5.721L8.277,6.387A1.336,1.336,0,0,0,6.388,8.277l5.721,5.708L6.388,19.693a1.336,1.336,0,1,0,1.889,1.889l5.708-5.721,5.708,5.721a1.336,1.336,0,1,0,1.889-1.889Z",
    transform: "translate(195.214 177.547)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus14);
export default __webpack_public_path__ + "static/media/status-14.7c840115b92cf765b2a2236d1eaf42c6.svg";
export { ForwardRef as ReactComponent };